import { useEffect, useState } from "react"
import styles from "./FBMManagement.module.scss"
import PartnerWarehouses from "../../../components/AdminPortalComponents/FBMManagement/PartnerWarehouses/PartnerWarehouses"
import WarehouseDetail from "../../../components/AdminPortalComponents/FBMManagement/PartnerWarehouses/WarehouseDetail/WarehouseDetail"
import Inventory from "../../../components/AdminPortalComponents/FBMManagement/Inventory/Inventory"
import Orders from "../../../components/AdminPortalComponents/FBMManagement/Orders/Orders"
import Returns from "../../../components/AdminPortalComponents/FBMManagement/Returns/Returns"
import DynamicFilterBar from "../../../components/common/AdminCommonComponents/FilterBars/DynamicFilterBar/DynamicFilterBar"
import BillingAndInvoice from "../../../components/AdminPortalComponents/FBMManagement/BillingAndInvoice/BillingAndInvoice"
import Performance from "../../../components/AdminPortalComponents/FBMManagement/Performance/Performance"

const FBMManagement = () => {
  const tabs = [
    { key: "partnerWarehouses", label: "Partner Warehouses" },
    { key: "inventory", label: "Inventory" },
    { key: "orders", label: "Orders" },
    { key: "returns", label: "Returns" },
    { key: "billingInvoicing", label: "Billing & Invoicing" },
    { key: "performance", label: "Performance" },
  ]

  // const [activeTab, setActiveTab] = useState(tabs[0].key)

  const [showWarehouseDetails, setShowWarehouseDetails] = useState(false)

  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("activeTab") || tabs[0].key;
  });

  // Save the active tab to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  return (
    <div className={styles["wrapper"]}>
      <div className="bg-white py-3 shadow">
        <DynamicFilterBar filterTabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} barType="top-bar" />
      </div>

      {showWarehouseDetails ? (
        <WarehouseDetail setShowWarehouseDetails={setShowWarehouseDetails} />
      ) : (
        <>
          {activeTab === "partnerWarehouses" && <PartnerWarehouses setShowWarehouseDetails={setShowWarehouseDetails} />}
          {activeTab === "inventory" && <Inventory />}
          {activeTab === "orders" && <Orders />}
          {activeTab === "returns" && <Returns />}
          {activeTab === "billingInvoicing" && <BillingAndInvoice />}
          {activeTab === "performance" && <Performance />}
        </>
      )}
    </div>
  )
}

export default FBMManagement
